import cx from '../../../../utils/cx';

import Typography, { FONT_TYPES } from '../Typography/Typography';

import styles from './MainButton.module.scss';

const MainButton = ({ children, isDisabledStyles, className, onClick, ...rest }) => {
  return (
    <button
      className={cx(styles.button, className, { [styles.disabled]: isDisabledStyles })}
      onClick={onClick}
      type="button"
      {...rest}
    >
      <Typography type={FONT_TYPES.button} htmlTag="span" isCenter>
        {children}
      </Typography>
    </button>
  );
};

export default MainButton;
